"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import Image from "next/image";
import { OfferedServices } from "@/lib/types";
import { useTypewriter } from "@/hooks/animations/useTypewriter";
interface ServiceSlabProps {
  service: OfferedServices;
  index: number;
  total: number;
  open: boolean;
}

// One slab of the rail. Its own component so the typewriter hook has a stable
// call site — a hook cannot live inside the parent's .map.
const ServiceSlab = t0 => {
  const $ = _c(51);
  const {
    service,
    index,
    total,
    open
  } = t0;
  const Icon = service.icon;
  let t1;
  if ($[0] !== service.title) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = /\.$/;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = service.title.replace(t2, "");
    $[0] = service.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const name = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      startDelay: 220
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const shown = useTypewriter(service.title, open, t2);
  const typing = open && shown < service.title.length;
  const t3 = `/services/${service.slug}`;
  const t4 = `${name} — view service`;
  const t5 = open ? 7 : 1;
  let t6;
  if ($[4] !== t5) {
    t6 = {
      flexGrow: t5,
      flexBasis: 0,
      minWidth: 0
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = `object-cover transition-all duration-700 ${open ? "scale-100 opacity-100" : "scale-110 opacity-40 grayscale"}`;
  let t8;
  if ($[6] !== service.heroImage || $[7] !== t7) {
    t8 = <Image src={service.heroImage} alt="" fill={true} sizes="(max-width: 1024px) 0px, 40vw" className={t7} />;
    $[6] = service.heroImage;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="absolute inset-0 bg-linear-to-t from-black/90 via-black/45 to-black/25" />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const t10 = `pointer-events-none absolute inset-0 transition-opacity duration-700 ${open ? "opacity-100" : "opacity-0"}`;
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      background: "radial-gradient(420px circle at 50% 100%, rgba(178,209,39,0.20), transparent 70%)"
    };
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== t10) {
    t12 = <div aria-hidden={true} className={t10} style={t11} />;
    $[11] = t10;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  const t13 = `pointer-events-none absolute inset-0 rounded-2xl border-2 transition-colors duration-500 ${open ? "border-primary/60" : "border-transparent"}`;
  let t14;
  if ($[13] !== t13) {
    t14 = <span aria-hidden={true} className={t13} />;
    $[13] = t13;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  const t15 = `relative z-10 m-auto whitespace-nowrap text-xs font-black uppercase tracking-[0.2em] text-white/80 transition-opacity duration-300 [writing-mode:vertical-rl] group-hover:text-white ${open ? "opacity-0" : "opacity-100"}`;
  let t16;
  if ($[15] !== name || $[16] !== t15) {
    t16 = <span className={t15}>{name}</span>;
    $[15] = name;
    $[16] = t15;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  const t17 = `absolute inset-x-0 bottom-0 z-10 flex flex-col p-5 transition-opacity duration-500 ${open ? "opacity-100 delay-200" : "pointer-events-none opacity-0"}`;
  let t18;
  if ($[18] !== Icon) {
    t18 = <span className="flex size-11 items-center justify-center rounded-full border-2 border-black bg-primary text-black"><Icon size={20} /></span>;
    $[18] = Icon;
    $[19] = t18;
  } else {
    t18 = $[19];
  }
  const t19 = `0${index + 1}`;
  const t20 = `0${total}`;
  let t21;
  if ($[20] !== t19 || $[21] !== t20) {
    t21 = <p className="mt-4 text-[10px] font-black uppercase tracking-[0.3em] text-primary">{t19} / {t20}</p>;
    $[20] = t19;
    $[21] = t20;
    $[22] = t21;
  } else {
    t21 = $[22];
  }
  let t22;
  if ($[23] !== service.title) {
    t22 = <span className="invisible" aria-hidden={true}>{service.title}</span>;
    $[23] = service.title;
    $[24] = t22;
  } else {
    t22 = $[24];
  }
  let t23;
  if ($[25] !== service.title || $[26] !== shown) {
    t23 = service.title.slice(0, shown);
    $[25] = service.title;
    $[26] = shown;
    $[27] = t23;
  } else {
    t23 = $[27];
  }
  let t24;
  if ($[28] !== typing) {
    t24 = typing && <span className="ml-0.5 inline-block h-[0.8em] w-[3px] translate-y-[0.06em] animate-pulse bg-primary align-middle" />;
    $[28] = typing;
    $[29] = t24;
  } else {
    t24 = $[29];
  }
  let t25;
  if ($[30] !== t23 || $[31] !== t24) {
    t25 = <span className="absolute inset-0">{t23}{t24}</span>;
    $[30] = t23;
    $[31] = t24;
    $[32] = t25;
  } else {
    t25 = $[32];
  }
  let t26;
  if ($[33] !== t22 || $[34] !== t25) {
    t26 = <h3 className="relative mt-1 text-2xl font-black uppercase leading-[0.95] tracking-tighter text-white">{t22}{t25}</h3>;
    $[33] = t22;
    $[34] = t25;
    $[35] = t26;
  } else {
    t26 = $[35];
  }
  let t27;
  if ($[36] !== t17 || $[37] !== t18 || $[38] !== t21 || $[39] !== t26) {
    t27 = <div className={t17}>{t18}{t21}{t26}</div>;
    $[36] = t17;
    $[37] = t18;
    $[38] = t21;
    $[39] = t26;
    $[40] = t27;
  } else {
    t27 = $[40];
  }
  let t28;
  if ($[41] !== open || $[42] !== t12 || $[43] !== t14 || $[44] !== t16 || $[45] !== t27 || $[46] !== t3 || $[47] !== t4 || $[48] !== t6 || $[49] !== t8) {
    t28 = <Link href={t3} aria-label={t4} aria-current={open} style={t6} className="group relative flex overflow-hidden rounded-2xl border border-transparent transition-[flex-grow] duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] data-[open=false]:hover:border-white/25" data-open={open}>{t8}{t9}{t12}{t14}{t16}{t27}</Link>;
    $[41] = open;
    $[42] = t12;
    $[43] = t14;
    $[44] = t16;
    $[45] = t27;
    $[46] = t3;
    $[47] = t4;
    $[48] = t6;
    $[49] = t8;
    $[50] = t28;
  } else {
    t28 = $[50];
  }
  return t28;
};
interface ServiceSliverRailProps {
  services: OfferedServices[];
  /** Scroll-driven active slide from the Services section. */
  activeIndex: number;
}

// The right-hand panel of the Services section: four vertical slabs, the active
// one opened to fill the frame while the rest collapse to labelled slivers.
//
// Replaces the old cursor image-trail, which spawned on pointer movement inside
// a scroll-driven section — so it drew nothing while the section was actually
// being read. This is driven by the same scroll `activeIndex` the progress bars
// use, and every slab is a real <Link>, so all four /services/[slug] pages sit
// in the panel rather than only the one link in the left column.
const ServiceSliverRail = t0 => {
  const $ = _c(8);
  const {
    services,
    activeIndex
  } = t0;
  let t1;
  if ($[0] !== activeIndex || $[1] !== services) {
    let t2;
    if ($[3] !== activeIndex || $[4] !== services.length) {
      t2 = (service, i) => <ServiceSlab key={service.id} service={service} index={i} total={services.length} open={i === activeIndex} />;
      $[3] = activeIndex;
      $[4] = services.length;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    t1 = services.map(t2);
    $[0] = activeIndex;
    $[1] = services;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = <div className="flex h-full w-full gap-2">{t1}</div>;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default ServiceSliverRail;